import { app } from '../app.module'
app
  /**
   * @ngdoc PostCtrl
   * @name PostCtrl
   * @requires PostService 投稿表示機能用のサービス
   * @description 投稿関連のコントローラー
   */
  .controller(
    'PostCtrl',
    (
      $rootScope,
      $scope,
      $state,
      $timeout,
      $filter,
      PostService,
      RestangularService,
      localStorageService,
      SnsSelectTabService
    ) => {
      // 投稿機能のフラグをチェックして、フラグがない場合は、アカウント > 分析 > ブランドの優先順位でリダイレクトする
      if ($rootScope.flgPost === false) {
        if ($rootScope.flgAccount === true) {
          $state.go('account')
        } else if ($rootScope.flgAnalytics === true) {
          $state.go('analytics')
        } else {
          $state.go('brand')
        }
      }
      // フィルタリングの対象をルートスコープに保存
      $rootScope.postTypeFilter = null
      $rootScope.messageFilter = null
      $rootScope.postTagFilter = null
      $rootScope.accountTagFilter = null
      $rootScope.hashtagFilter = null
      $rootScope.followerFilter = null
      $rootScope.durationFilter = null
      $rootScope.favoriteFilter = null
      $rootScope.accountGlobalFilter = null
      $rootScope.inFilter = null
      $scope.selectTab = selectTab

      // SNSタブのインデックスを取得
      const tabIndex = SnsSelectTabService.getTabIndex()

      // ローカルストレージに保存されているSNSの選択状態を取得し、タブの選択処理を行う
      let selectedSns = localStorageService.get('selectedSns')

      // SNSの選択状態がローカルストレージに保存されていない場合、facebookにする
      if (selectedSns === null) {
        selectedSns = 'facebook'
      }

      // ローカルストレージに保存されていたSNSの利用許可があるかチェックしたのちに、タブの選択処理を行う
      const checkedSns = SnsSelectTabService.checkLocalTab(selectedSns)

      selectTab(checkedSns)
      $scope.snsType = $scope.selectedTab

      /**
       * タブが選択された際の処理
       * 選択されたSNSをスコープにセットし、初期化を行う
       * @param {string} selectedSns 選択されたSNS
       */
      function selectTab(selectedSns) {
        // 同じSNSのタブの場合は、何も処理をしない
        if ($scope.selectedTab === selectedSns) {
          return
        }
        if (selectedSns !== null) {
          $scope.selectedTab = selectedSns
          $scope.snsType = selectedSns

          switch (selectedSns) {
            case 'facebook':
              $scope.selectedTabIndex = tabIndex.facebook
              break
            case 'twitter':
              $scope.selectedTabIndex = tabIndex.twitter
              break
            case 'instagram':
              $scope.selectedTabIndex = tabIndex.instagram
              break
            case 'youtube':
              $scope.selectedTabIndex = tabIndex.youtube
              break
            case 'line':
              $scope.selectedTabIndex = tabIndex.line
              break
            case 'tiktok':
              $scope.selectedTabIndex = tabIndex.tiktok
              break
          }
        }

        if ($scope.selectedTab !== undefined) {
          // スコープの初期化
          initPostScope()

          // ローカルストレージにSNSの選択状態を保存
          localStorageService.set('selectedSns', $scope.selectedTab)
        }
      }

      /**
       * initPostScope 投稿機能に必要なスコープを初期化
       * @return {void}
       */
      function initPostScope() {
        // アカウント情報を表示するフラグ(アカウント情報と投稿の日付)
        $scope.showAccountInfoFlg = 'account-post-date'
        // テーブルクエリ設定
        $scope.query = {
          order: 'engagements',
          limit: 25,
          options: [10, 25, 50],
          page: 1,
          postsCount: null,
        }
        if ($scope.selectedTab === 'youtube') {
          $scope.query.order = 'views'
        }

        if ($scope.selectedTab === 'tiktok') {
          $scope.query.order = 'plays'
        }
        // キーワード検索
        $rootScope.messageFilter = null
        // メインカテゴリ
        $scope.categoryName = null
        // サブカテゴリ
        $scope.subCategoryName = null

        // アカウントフィルタをリセット
        $scope.accountFilter = null

        let excludePostType = []

        switch ($scope.selectedTab) {
          case 'twitter':
            excludePostType = ['link', 'carousel', 'album', '360-video', 'offer', 'note']
            break

          case 'instagram':
            excludePostType = [
              'text',
              'animation-gif',
              'link',
              'carousel',
              'album',
              '360-video',
              'offer',
              'note',
            ]
            break
        }

        // 指定されているタイプがSNSにあってない場合、nullにする
        if (excludePostType.indexOf($rootScope.postTypeFilter) !== -1) {
          $rootScope.postTypeFilter = null
        }

        const privateFlg = $filter('filter')($rootScope.followerFilter, '非公開')

        // youtubeではない場合 and 非公開でフィルタリング中の場合、非公開条件を削除
        if ($scope.selectedTab !== 'youtube' && privateFlg !== null && privateFlg.length > 0) {
          $rootScope.followerFilter = $rootScope.followerFilter.filter((follower) => {
            return follower !== '非公開'
          })

          if ($rootScope.followerFilter.length === 0) {
            $rootScope.followerFilter = null
          }
        }

        $scope.postsDataAverage = {
          likes: 0,
          comments: 0,
          retweets: 0,
          shares: 0,
          engagements: 0,
          engagementRates: 0,
        }

        $scope.sortPosts = []
        // 一括タグ追加を行う対象のIDの配列
        $scope.selectedIds = []
      }

      // 期間指定(デフォルトは1日前から7日間)
      const startEndDate = {
        startDate: moment(moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00')).unix(),
        endDate: moment(moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00')).unix(),
      }

      // 投稿一覧のチェックボックスにチェックを入れた際の処理
      $scope.$on('addTargetId', (event, targetId: number) => {
        // チェックを入れた変更対象のIDを配列として保持する
        $scope.selectedIds.push(targetId)
      })

      // 投稿一覧のチェックボックスのチェックを外した際の処理
      $scope.$on('removeTargetId', (event, targetId: number) => {
        // IDを変更対象の配列から削除する
        const filterdArray: [number] = $scope.selectedIds.filter((element: number) => {
          return element !== targetId
        })
        $scope.selectedIds = filterdArray
      })

      // 選択のリセットボタンを押した際の処理
      $scope.$on('resetAllSelectedIds', () => {
        // 選択中のIDの配列を全て空にする
        $scope.selectedIds = []
        $scope.$broadcast('resetCheckBox')
      })

      // テーブルをリロードする
      $scope.$on('reloadTable', () => {
        // フィルタリングを行う
        getAllPosts($scope.selectedTab, startEndDate)
      })

      /**
       * getAllPosts 全投稿のデータを取得
       * @param {string} snsType SNSタイプ
       * @param {object} selectedStartEndDate 選択した期間
       * @return {void}
       */
      function getAllPosts(
        snsType: string,
        selectedStartEndDate: {
          startDate: number
          endDate: number
        }
      ) {
        let setPosts

        switch (snsType) {
          case 'facebook':
            setPosts = PostService.FbPost.setFbPosts
            break

          case 'twitter':
            setPosts = PostService.TwPost.setTwPosts
            break

          case 'instagram':
            setPosts = PostService.InPost.setInPosts
            break

          case 'youtube':
            setPosts = PostService.YtPost.setYtPosts
            break

          case 'line':
            setPosts = PostService.LinePost.setLinePosts
            break

          case 'tiktok':
            setPosts = PostService.TikTokPost.setTikTokPosts
            break
        }

        // ロードフラグをセット
        $scope.isLoading = true
        // 取得のパラメーター
        $scope.getOptions = {
          startEndDate: selectedStartEndDate,
          categoryFilter: $scope.categoryName,
          subCategoryFilter: $scope.subCategoryName,
          accountFilter: $scope.accountFilter,
          postTypeFilter: $rootScope.postTypeFilter ? $rootScope.postTypeFilter : null,
          messageFilter: $rootScope.messageFilter,
          tagFilter: $rootScope.postTagFilter,
          accountTagFilter: $rootScope.accountTagFilter,
          hashtagFilter: $rootScope.hashtagFilter,
          followerFilter: $rootScope.followerFilter,
          durationFilter: $rootScope.durationFilter,
          favoriteFilter: $rootScope.favoriteFilter,
          accountGlobalFilter:
            $rootScope.accountGlobalFilter >= 0 ? $rootScope.accountGlobalFilter : null,
          inFilter: $rootScope.inFilter,
          groupId: $rootScope.groupId,
          isPro: $rootScope.isPro,
          userId: $rootScope.userId,
          limit: $scope.query.limit,
          order: $scope.query.order,
          page: $scope.query.page,
          postsCount: $scope.query.postsCount,
        }

        // 投稿一覧を取得
        RestangularService.request('GET', '/post/list', {
          options: JSON.stringify($scope.getOptions),
          snsType: snsType,
        }).then((result) => {
          PostService.Action.accountLists = null
          PostService.Action.tagLists = null
          PostService.Action.accountTagLists = null
          PostService.Action.hashtagLists = null
          const posts = result[0].data

          if ($scope.getOptions.postsCount === null && posts !== null && posts.length > 0) {
            // データの平均と投稿件数を取得
            RestangularService.request('GET', 'post/list', {
              options: JSON.stringify($scope.getOptions),
              snsType: snsType,
              type: 'average',
            }).then((result) => {
              const averageData = result[0].data
              $scope.query.postsCount = averageData.postsCount
              $scope.getOptions.postsCount = averageData.postsCount
              $scope.postsDataAverage = averageData.postsDataAverage
            })
          }

          // 投稿のデータをセットしてスコープに保存
          $scope.sortPosts = setPosts(posts)

          // ロードフラグを解除
          $scope.isLoading = false
        })
      }

      /**
       * フィルターの変更
       */
      function changeFilter() {
        // ページングを初期化
        $scope.query.page = 1
        // 投稿の数をリセット
        $scope.query.postsCount = null
        // 選択中のIDの配列を全て空にする
        $scope.selectedIds = []
        // フィルタリングを行う
        getAllPosts($scope.selectedTab, startEndDate)
      }

      // ページングを移動するイベント
      $scope.onPaginate = function (page, limit) {
        $scope.query.page = page
        $scope.query.limit = limit
        getAllPosts($scope.selectedTab, startEndDate)
        $scope.$broadcast('onPaginate')
      }

      // ソートのイベント
      $scope.onReorder = function (order) {
        // ページングを初期化
        $scope.query.page = 1
        $scope.query.order = order
        getAllPosts($scope.selectedTab, startEndDate)
      }

      /**
       * ハッシュタグフィルターデータをセット
       * @param {string} searchStrings 検索文字列
       */
      $scope.queryHashtagSearch = (searchStrings: string) => {
        return PostService.Search.getHashtagList(
          searchStrings,
          $scope.selectedTab,
          $scope.getOptions
        )
      }

      /**
       * アカウントフィルターデータをセット
       * @param {string} searchStrings 検索文字列
       */
      $scope.queryAccountSearch = (searchStrings: string) => {
        return PostService.Search.queryFilterSearch(
          searchStrings,
          'getAccount',
          $scope.selectedTab,
          $scope.getOptions
        )
      }

      /**
       * フォロワー数範囲の変更イベント
       * @param {string[]} followerRange フォロワー数範囲
       */
      $scope.changeFollowerFilter = (followerRange: string[]) => {
        if ($rootScope.followerFilter === followerRange) {
          return
        }
        $rootScope.followerFilter = followerRange
        // フィルターを変更する
        changeFilter()
      }

      /**
       * アカウントグローバルの変更イベント
       * @param {number} accountGlobal アカウントグローバル
       */
      $scope.changeAccountGlobalFilter = (accountGlobal: number) => {
        if ($rootScope.accountGlobalFilter === accountGlobal) {
          return
        }
        $rootScope.accountGlobalFilter = accountGlobal
        // フィルターを変更する
        changeFilter()
      }

      /**
       * キーワードの変更イベント
       * @param {string} keyword キーワード
       */
      $scope.changeKeywordFilter = (keyword: string) => {
        if ($rootScope.messageFilter === keyword) {
          return
        }
        $rootScope.messageFilter = keyword
        // フィルターを変更する
        changeFilter()
      }

      /**
       * 投稿タイプの変更イベント
       * @param {string} postType 投稿タイプ
       */
      $scope.changePostType = (postType: string) => {
        if ($rootScope.postTypeFilter === postType) {
          return
        }
        $rootScope.postTypeFilter = postType
        // フィルターを変更する
        changeFilter()
      }

      /**
       * ハッシュタグの変更イベント
       * @param {string} searchStrings 検索文字列
       */
      $scope.changeHashtag = (searchStrings: string) => {
        if ($rootScope.hashtagFilter === searchStrings) {
          return
        }
        $rootScope.hashtagFilter = searchStrings
        // フィルターを変更する
        changeFilter()
      }

      /**
       * 選択した投稿タグリストの変更イベント
       * @param {string[]} selectedTags 選択したタグリスト
       * @returns void
       */
      $scope.changeSelectedPostTags = (selectedTags: string[]) => {
        $rootScope.postTagFilter = selectedTags
        // フィルターを変更する
        changeFilter()
      }

      // 一覧のタグがクリックされた場合、フィルタリングを行う
      $scope.$on('clickPostTableTag', (event: any, tagName: string) => {
        if ($rootScope.postTagFilter && $rootScope.postTagFilter.length > 0) {
          $rootScope.postTagFilter.push(tagName)
        } else {
          $rootScope.postTagFilter = [tagName]
        }

        // フィルターを変更する
        changeFilter()
      })

      /**
       * 選択したアカウントタグリストの変更イベント
       * @param {string[]} selectedTags 選択したタグリスト
       * @returns void
       */
      $scope.changeSelectedAccountTags = (selectedTags: string[]) => {
        $rootScope.accountTagFilter = selectedTags
        // フィルターを変更する
        changeFilter()
      }

      /**
       * アカウント検索の変更イベント
       * @param {string} searchStrings 検索文字列
       */
      $scope.changeAccountSearch = (searchStrings: string) => {
        if ($scope.accountFilter === searchStrings) {
          return
        }
        $scope.accountFilter = searchStrings
        // フィルターを変更する
        changeFilter()
      }

      // ディレクティブから、'changeFilterData'を受信した場合
      $scope.$on('changeFilterData', (event, filterInfo) => {
        switch (filterInfo.type) {
          // サブカテゴリのフィルタリング
          case 'subCategoryFilter':
            // 投稿のサブカテゴリではない場合は、リターン
            if (filterInfo.subCategoryType !== 'post') {
              return
            }
            $scope.subCategoryName = filterInfo.value
            break
        }

        // フィルターを変更する
        changeFilter()
      })

      // 対象日付の変更を検知して投稿一覧情報を描画
      $scope.$watch(
        () => {
          return $scope.startEndDate
        },
        () => {
          if ($scope.startEndDate !== undefined) {
            // date-range-pickerで期間を指定した場合、セット
            if ($scope.startDate !== undefined && $scope.endDate !== undefined) {
              startEndDate.startDate = $scope.startDate
              startEndDate.endDate = $scope.endDate
              // ページングを初期化
              $scope.query.page = 1
              // 投稿の数をリセット
              $scope.query.postsCount = null
              // 選択中のIDの配列を全て空にする
              $scope.selectedIds = []
              // 期間でFB投稿一覧を取得
              getAllPosts($scope.selectedTab, startEndDate)
            }
          }
        }
      )

      // brandCategoryFormディレクティブから、'changeBrandCategory'を受信した場合
      $scope.$on(
        'changeBrandCategory',
        (
          event,
          categoryInfo: {
            type: string
            categoryName: string
            subCategoryName: string
          }
        ) => {
          if (categoryInfo.type !== 'post') {
            return
          }
          // 選択したメインカテゴリ、サブカテゴリをセット
          $scope.categoryName = null
          $scope.subCategoryName = null

          // メインカテゴリがある場合、スコープへカテゴリ、サブカテゴリを格納
          if (categoryInfo !== null) {
            $scope.categoryName = categoryInfo.categoryName
            $scope.subCategoryName =
              categoryInfo.subCategoryName !== '指定しない' ? categoryInfo.subCategoryName : null
          }

          // ページングを初期化
          $scope.query.page = 1
          // 投稿の数をリセット
          $scope.query.postsCount = null
          // 選択中のIDの配列を全て空にする
          $scope.selectedIds = []
          // 期間でFB投稿一覧を取得
          if ($rootScope.groupId !== undefined && $rootScope.userId !== undefined) {
            getAllPosts($scope.selectedTab, startEndDate)
          } else {
            // グループID、ユーザーIDが未取得の場合は、0.2秒待って、再度全投稿を取得する
            $timeout(() => {
              getAllPosts($scope.selectedTab, startEndDate)
            }, 200)
          }
        }
      )
    }
  )
